<template>
  <div class="fieldtable">
    <el-table
      :data=fields
      empty-text="No Fields Found"
      style="width: 100%">
      <el-table-column
         label="Name"
         prop="field_name"
         header-align="center">
      </el-table-column>
       <el-table-column
         label="Type"
         prop="type_id"
         :formatter="humanizeType"
         header-align="center">
      </el-table-column>
       <el-table-column
         label="Light Type"
         prop="light_type"
         header-align="center">
      </el-table-column>
       <el-table-column
         label="Restrike Time"
         prop="min_off_time"
         header-align="center">
      </el-table-column>
      <el-table-column
         label="Light Status"
         prop="light_status"
         header-align="center">
         <template slot-scope="scope">
            <div v-if="scope.row.light_status === 1">
              <el-tag type="success">{{ getSceneName(scope.row.id) }}</el-tag>
            </div>
            <div v-else>
              <el-tag type="danger">Off</el-tag>
            </div>
          </template>
        </el-table-column>
      <el-table-column
        v-if="userIsSuperAdmin"
        label="Operations"
        align="center">
          <template slot-scope="props">
            <operations 
              :id="props.row.id" 
              :showLights="true"
              @view="viewScenes" 
              @lights="viewLights"
              @edit="editField(props.row)" 
              @delete="deleteField">
            </operations>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import auth from '../../../auth'
  import requests from '../../../requests';

  import operations from '../OpButtons.vue';

  export default {
    name: 'fieldtable',
    props:['clientId', 'id'],
    data () {
      return {
        fields:[],
        fieldsScenes: [],
        types: [],
        userIsSuperAdmin: false,
      }
    },
    beforeMount(){
      var profile = JSON.parse(auth.getProfile());
      this.userIsSuperAdmin = (profile.role === 3);
      // this.userIsSuperAdmin = true;

      var context = this;

      requests.getFieldTypes(this, function(result){
        context.types = result.data;
      });
    
      requests.getFields(this, context.id, function(result){
        if(result.action === 'success' && result.data) {
          
          var fields = result.data;
          
          for(var i = 0; i < fields.length; i++) {
            if(!fields[i].deleted)
              context.fields.push(fields[i]);
            
            if(!fields[i].power_relay){
              context.$set(fields[i], 'power_relay', '')
              context.$set(fields[i], 'logical_no', '')
            }
          }

          requests.getFieldsScenes(context, function(res){
            if(res.action === 'success') {
              context.fieldsScenes = res.data;
            }
          });
          
        } else {
          context.$message({
            type: 'error',
            message: 'Failed to recieve fields: ' + result.msg
          });
        }
      });
    },
    methods: {
      getSceneName(id) {

        if(this.fieldsScenes){
          for (var i = 0; i < this.fieldsScenes.length; i++) {
            var fs = this.fieldsScenes[i];
            if(fs.field_id === id) {
              return fs.scene_name;
            }
          }
          return "On";
        } else {
          console.log("Error processing getSceneName in FieldTable.vue");
          return "On";
        }

      },
      humanizeType(row){
        var a = this.types.filter((v)=>{ return v.id == row.type_id });
        if(a && a[0]) {
          return a[0].name;
        } else {
          return row.id;
        }
      },
      viewScenes(id) {
        this.$router.push({path: `/admin/clients/${this.clientId}/site/${this.id}/field/${id}`});
      },
      viewLights(id) {
        this.$router.push({path: `/admin/clients/${this.clientId}/site/${this.id}/field/${id}/lights`});        
      },
      editField(fieldData) {
        console.log(fieldData);
        this.$emit('editField', fieldData);
      },
      deleteField(id) {
        this.$emit('deleteField', id);
      },
    },
    components: {
      'operations': operations
    }
  }
  

</script>

<style>
  .el-table .cell {
    word-break: normal !important;
  }

</style>




// WEBPACK FOOTER //
// FieldTable.vue?d268e5d4